/* eslint-disable typescript-sort-keys/interface */
import React, { FC, memo } from 'react';

import classNames from 'classnames';
import styles from './LastOnlineStatus.module.scss';
interface Props {
  lastOnlineHour: number | undefined;
}
const LastOnlineStatus: FC<Props> = ({ lastOnlineHour }) => {
  const { lastOnlineLabel, isLastOnlineWithHour } = getOnlineStatus(lastOnlineHour);

  return (
    <>
      {lastOnlineLabel && (
        <div>
          <div
            className={classNames(styles['online-icon'], {
              [styles['icon-with-hour']]: Boolean(isLastOnlineWithHour),
            })}
          ></div>
          <div className={styles['last-online-label']}>{lastOnlineLabel}</div>
        </div>
      )}
    </>
  );
};

export default memo(LastOnlineStatus);

type OnlineStatus = {
  lastOnlineLabel: string | undefined;
  isLastOnlineWithHour: boolean;
};

function getOnlineStatus(lastOnlineHour: number | undefined): OnlineStatus {
  const TWO_DAYS = 48;
  const FIVE_DAYS = 120;

  if (lastOnlineHour !== undefined) {
    // 1. if lastOnlineHour is 0 to 47, display "n HOUR ago"(if n = 0, by default 1)
    if (lastOnlineHour >= 0 && lastOnlineHour < TWO_DAYS) {
      return {
        lastOnlineLabel: `${lastOnlineHour === 0 ? 1 : lastOnlineHour}時間以内`,
        isLastOnlineWithHour: true,
      };
    }
    // 2. else if hour is 48 to 120, display "n DAYS ago"
    if (lastOnlineHour >= TWO_DAYS && lastOnlineHour <= FIVE_DAYS) {
      const DATE_TO_HOUR = 24;
      return {
        lastOnlineLabel: `${Math.floor(lastOnlineHour / DATE_TO_HOUR)}日以内`,
        isLastOnlineWithHour: false,
      };
    }
  }
  // 3. else if hour is greater than 120, NOT display anything
  return { lastOnlineLabel: undefined, isLastOnlineWithHour: false };
}
